import { userTypes } from '@const'
import { wrapDocuments } from '@js/helpers/DocumentContainer'
export class KycTemplateParser {
  static fromTemplate (template, type) {
    switch (type) {
      case userTypes.syndicate:
        return {
          website: template.website,
          companyName: template.company_name,
          industry: template.industry || '',
          phoneNumber: template.phone_number,
          country: template.address && template.address.country ? template.address.country : template.country || '',
          city: template.address && template.address.city ? template.address.city : template.city || '',
          street: template.address && template.address.street ? template.address.street : template.street || '',
          zipCode: template.address && template.address.zip_code ? template.address.zip_code : template.zip_code || '',
          firstName: template.first_name,
          lastName: template.last_name,
          idDocumentType: template.id_document_type,
          idDocumentNumber: template.id_document_number,
          residenceCountry: template.residence_country || '',
          residenceCity: template.residence_city,
          residenceAddress: template.residence_address,
          residenceZipCode: template.residence_zip_code,
          privacyPolicy: template.privacy_policy || false,
          documents: wrapDocuments(template.documents)
        }
      case userTypes.general:
        return {
          firstName: template.first_name,
          lastName: template.last_name,
          idDocumentType: template.id_document_type,
          idDocumentNumber: template.id_document_number,
          residenceCountry: template.residence_country || '',
          residenceCity: template.residence_city,
          residenceAddress: template.residence_address,
          residenceZipCode: template.residence_zip_code,
          dateOfBirth: template.date_of_birth,
          privacyPolicy: template.privacy_policy || false,
          documents: wrapDocuments(template.documents)
        }
      case userTypes.individual:
        return {
          firstName: template.info.firstName || '',
          lastName: template.info.lastName || '',
          idDocumentType: template.info.idDocs[0].idDocType || '',
          idDocumentNumber: template.info.idDocs[0].number || '',
          residenceCountry: template.info.country || '',
          residenceCity: '',
          residenceAddress: template.info.addresses[0].state || '',
          residenceZipCode: '',
          dateOfBirth: template.info.dob || '',
          privacyPolicy: false,
          documents: ''
        }
      case userTypes.company:
        return {
          companyName: template.info.companyInfo.companyName,
          country: template.info.companyInfo.country,
          documents: wrapDocuments(template.documents)
        }
    }
  }
  static toTemplate (form, type) {
    switch (type) {
      case userTypes.syndicate:
        return {
          website: form.website,
          company_name: form.companyName,
          industry: form.industry,
          phone_number: form.phoneNumber,
          address: {
            street: form.street,
            zip_code: form.zipCode,
            country: form.country,
            city: form.city
          },
          first_name: form.firstName,
          last_name: form.lastName,
          id_document_type: form.idDocumentType,
          id_document_number: form.idDocumentNumber,
          residence_country: form.residenceCountry,
          residence_city: form.residenceCity,
          residence_address: form.residenceAddress,
          residence_zip_code: form.residenceZipCode,
          privacy_policy: form.privacyPolicy
        }
      case userTypes.company:
        return {
          website: form.website,
          company_name: form.companyName,
          industry: form.industry,
          phone_number: form.phoneNumber,
          address: {
            street: form.street,
            zip_code: form.zipCode,
            country: form.country,
            city: form.city
          },
          first_name: form.firstName,
          last_name: form.lastName,
          id_document_type: form.idDocumentType,
          id_document_number: form.idDocumentNumber,
          residence_country: form.residenceCountry,
          residence_city: form.residenceCity,
          residence_address: form.residenceAddress,
          residence_zip_code: form.residenceZipCode,
          privacy_policy: form.privacyPolicy
        }
      case userTypes.general:
        return {
          first_name: form.firstName,
          last_name: form.lastName,
          id_document_type: form.idDocumentType,
          id_document_number: form.idDocumentNumber,
          residence_country: form.residenceCountry,
          residence_city: form.residenceCity,
          residence_address: form.residenceAddress,
          residence_zip_code: form.residenceZipCode,
          date_of_birth: form.dateOfBirth,
          privacy_policy: form.privacyPolicy
        }
    }
  }

  static getSaveableDocuments (documents) {
    const result = {}
    for (const [type, doc] of Object.entries(documents)) {
      if (doc) result[type] = doc.getDetailsForSave()
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/kyc-template-parser.js